<div class="upload-file d-flex flex-column" [ngClass]="{'has-file': availableFiles.length > 0}">
  <div class="d-flex flex-row file-bag">
    <div #FilesContainer class="file-bag-row">
        <div class="row">
          <div class="col-md-6 file-item" *ngFor="let file of availableFiles; let i = index">
            <preview-file [ngClass]="{'last-line': isLastLine(i), 'odd-line': isOddLine(i)}" (downloadFile)="downloadFile($event)" (removeFileEvent)="removeFile($event)" [file]="file"></preview-file>
          </div>
        </div>
    </div>
  </div>
  <div class="d-flex justify-content-center upload-btn">
    <div *ngIf="enableUpload" class="file btn btn-primary" [ngClass]="{'read-only': isReadOnly}">
      {{'campaigns.upload_file' | translate}}
      <input type="file" name="file" (change)="onMaterialFileSelected($event)" [disabled]="isReadOnly">
    </div>
    <loading-spinner *ngIf="!enableUpload"></loading-spinner>
  </div>
</div>
<achoo-popup #WarningErrorUploadFile
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}">
  <span>{{validationMsg}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/campaigns-add/upload-file/upload-file.component.html